import type { PointLight } from "@babylonjs/core/Lights/pointLight";

export class LightingController {
  private elapsed = 0;
  private readonly secondaryBaseIntensities: readonly number[];

  public constructor(
    private readonly emergencyLight: PointLight,
    private readonly secondaryLights: readonly PointLight[],
    private readonly emergencyPulseEnabled: boolean,
  ) {
    this.secondaryBaseIntensities = secondaryLights.map((light) => light.intensity);
    if (!emergencyPulseEnabled) emergencyLight.intensity = 0;
  }

  public update(deltaSeconds: number): void {
    this.elapsed += deltaSeconds;
    if (this.emergencyPulseEnabled) {
      const pulse = Math.sin(this.elapsed * 8.7) * 0.18 + Math.sin(this.elapsed * 2.1) * 0.12;
      this.emergencyLight.intensity = 1.15 + pulse;
    }
    for (let index = 0; index < this.secondaryLights.length; index += 1) {
      const light = this.secondaryLights[index];
      const baseIntensity = this.secondaryBaseIntensities[index];
      if (light && baseIntensity !== undefined) light.intensity = baseIntensity;
    }
  }
}
